export default __webpack_public_path__ + "static/media/settings.4ced4fdd.png";